var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputComma",attrs:{"type":"text"},domProps:{"value":_vm.commaValue},on:{"change":_vm.updateChange,"input":_vm.updateInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }